export const mutations = {
  SET_USER_INFO: (state, info) => {
    state.userInfo = info;
  },
  SIGNIN_OUT (state) {
    state.userInfo = {};
  },
  SET_NAV_LIST: (state, list) => {
    state.navList = list;
  },
  RESET_NAV_LIST (state) {
    state.navList = null;
  },
  SET_CLICK_TOKEN (state, clickToken) {
    state.clickToken = clickToken;
  },
  SET_TENANT_PARAMS: (state, info) => {
    state.tenantParams = info;
  },
  SET_APP_QR_CODE_SHOW: (state, info) => {
    state.showAppQRCode = info;
  },
  SET_SHOW_AREA_CODE: (state, code) => {
    state.showAreaCode = code;
  }
};
